import React, { Component } from "react";
import ROUTES from "../../constants/routes";
import { NavLink, withRouter } from "react-router-dom";
import ls from 'localstorage-slim';

import "./NavigationTabs.sass";

class NavigationTabs extends Component {
  isPageActive = (match, location, title) => {
    const isIframe = location.pathname.includes('/iframe');

    return match ||
      (isIframe && title === "Iframes");
  };

  render() {
    const user = ls.get("user");

    const links = [
      {
        title: 'Info',
        route: ROUTES.PROMOTER_INFO,
      },
      {
        title: 'Templates',
        route: ROUTES.PROMOTER_TEMPLATES,
      },
      {
        title: 'Iframes',
        route: ROUTES.PROMOTER_IFRAMES,
      },
      {
        title: 'Statistics',
        route: ROUTES.PROMOTER_STATISTICS,
      },
    ];

    if (user.hasPayNlAccount) {
      links.push({
        title: 'Balance',
        route: ROUTES.PROMOTER_BALANCE,
      })
    }

    return (
      <nav className="nav-tabs">
        <div className="nav-tabs__container nav-tabs__container--small">
          {links.map(link => {
            return (
              <NavLink
                className="nav-tabs__item"
                to={link.route}
                key={link.route}
                isActive={(match, location) =>
                  this.isPageActive(match, location, link.title)
                }
              >
                <span>{link.title}</span>
              </NavLink>
            )
          })}
        </div>
      </nav>
    ); 
  }
};

export default withRouter(NavigationTabs);

